import SentryWrappedError from "./SentryWrappedError";

export default class InternalServerErrorResponse extends SentryWrappedError {
  constructor(request: Request, response: Response) {
    super("Something went wrong on our end. We’ve been notified and will fix it as soon as possible.");

    const url = new URL(response.url);
    this.sentryMessage = "An unexpected error ocurred.";
    this.sentryTitle = `${response.status} - ${request.method} ${url.pathname + url.search}`;
  }
}
